
export default {
  name: "PopUpForm",

  data() {
    return {
      isUploaded: false,
      isSending: false,
      fullname: '',
      youremail: '',
      yourphone: '',
      company: '',

    }
  },
  computed: {
    checked() {
      return this.fullname.length > 3 && this.youremail.length > 3 && this.yourphone.length > 3
    }
  },
  methods: {
    upload() {
      setTimeout(() => this.isUploaded = true, 2000)
    },
    sending() {
      this.isSending = true
      setTimeout(this.close, 2000)
    },
    close() {
      this.$emit('close')
      this.isSending = false
      this.isUploaded = false
      this.fullname = ''
      this.youremail = ''
      this.phone = ''
      this.company = ''
    }
  }
}
